<ng-container>
    <div>
        <div class="shop-layout shop-layout--sidebar--{{ sidebarPosition }}">
            <!-- <app-widget-advanced-search *ngIf="advancedSearch" [offcanvas]="advancedSearch.offcanvas" [companyId]="advancedSearch.companyId" [type]="advancedSearch.type" [searchInfo]="advancedSearch.searchInfo" [subtypeId]="advancedSearch.subtypeId" offcanvas="always"></app-widget-advanced-search> -->
            <div class="shop-layout__sidebar" *ngIf=" showSidebar == 'true' && sidebarPosition === 'start' && (filtersData?.length || categoryData)">
                <div class="block block-sidebar">
                    <app-shop-sidebar  offcanvas="mobile"></app-shop-sidebar>
                </div>
            </div>
            <div class="{{showSidebar=='true' && (filtersData?.length || categoryData)?'shop-layout__content':'shop-layout__content_full'}}">

                <!-- <app-products-view [products]="products" [layout]="viewMode" grid="grid-4-full" offcanvas="always"></app-products-view> -->
                <div class="block">
                    <!--    <app-subcategories-carousel *ngIf="subcategories.items?.length > 0 || subcategories.parent"
                        [parent]="subcategories.parent" [subcategories]="subcategories.items" [type]="'/vendor'"
                        [pageSlug]="companyData?.seo?.slug"></app-subcategories-carousel> -->

                    <!-- <app-products-view *ngIf="products" 
                        [productsCount]="productsCount" [products]="products" [layout]="viewMode" [showSidebar]="showSidebar"
                        grid="grid-4-full" offcanvas="mobile"></app-products-view> -->

                    <app-products-view *ngIf="products" [itemsView]="view" [productsCount]="productsCount"
                        [products]="products" [layout]="viewMode" [showSidebar]="showSidebar"
                        offcanvas="mobile"></app-products-view>
                </div>
            </div>

        </div>
    </div>
</ng-container>